export default {
  title: '{title} na Intee',
  titleHome: 'Intee – Propoj se s dalšími lidmi',
};
